"use client";

import SideMenu from "@/components/Sidemenu";
import GuideCard from "@/components/GuideCard";
import { share } from "@/lib/share";

export default function DesktopSidebar({ menuContent, page }) {
  return (
    <div className="sticky top-[60px] z-40 mb-5 w-full self-start md:top-[100px] lg:top-[150px] lg:mb-0">
      <div className="flex w-full flex-col gap-10">
        <div className="flex w-full flex-col gap-5">
          <SideMenu content={menuContent} />
          <button
            type="button"
            onClick={() => share()}
            className="hidden cursor-pointer flex-row items-center justify-end gap-3 lg:flex"
          >
            Partager
            <img src="/icons/share.svg" alt="" width={20} height={20} aria-hidden />
          </button>
        </div>
        <GuideCard page={page} />
      </div>
    </div>
  );
}
